import { object, string } from 'yup'

import { i18nErrorCodes } from '../form-utils'

const { required } = i18nErrorCodes

export interface TripartitaTeacherInitialValues {
  challenge: string
  objectives: string
}

export const tripartitaTeacherInitialSchema = object().shape({
  challenge:  string().required(required),
  objectives: string().required(required),
})

export const emptyTripartitaTeacherInitial: TripartitaTeacherInitialValues = {
  challenge:  '',
  objectives: '',
}

export interface TripartitaStudentInitialValues {
  indicators: string
}

export const tripartitaStudentInitialSchema = object().shape({
  indicators: string().required(required),
})

export const emptyTripartitaStudentInitial: TripartitaStudentInitialValues = {
  indicators: '',
}

export interface TripartitaFollowupValues {
  commitment: string
  superiorCommitment: string
}

export const tripartitaFollowupSchema = object().shape({
  commitment:         string().required(required),
  superiorCommitment: string().required(required),
})

export const emptyTripartitaFollowup: TripartitaFollowupValues = {
  commitment:         '',
  superiorCommitment: '',
}

export type FinalTripartitaValues = TripartitaFollowupValues

export const emptyFinalTripartitaSchema = emptyTripartitaFollowup



// WEBPACK FOOTER //
// ./src/components/forms/schemas/tripartita.schema.ts